// action
import {
    GET_APPOINTMENT_DETAILS,
    GET_APPOINTMENT_DETAILS_FAIL,
    GET_APPOINTMENT_DETAILS_SUCCESS,
    GET_APPOINTMENT_DETAILS_RESET
} from '../action/getAppointmentDetailsAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action) {
    switch (action.type) {
        case GET_APPOINTMENT_DETAILS:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_APPOINTMENT_DETAILS_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_APPOINTMENT_DETAILS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_APPOINTMENT_DETAILS_RESET:
            return initialState
        default:
            return state
    }
}